import React, { useContext } from 'react';
import { HeaderContainer, HeaderElement } from './Header.styles'
import { ReactComponent as TwitterLogo } from '../../../assets/icons/twitter.svg'
import { ReactComponent as LinkedinLogo } from '../../../assets/icons/linkedin.svg'
import { ReactComponent as GitHubLogo } from '../../../assets/icons/github.svg'
import IconChart from '../../chartComponents/IconChart/IconChart';
import { ScrollContext } from '../../context/ScrollContext';

const Header = () => {
    const { color } = useContext(ScrollContext)
    
    return ( 
        <HeaderContainer>
            <HeaderElement>
                <div>
                    <IconChart
                    fill={color}
                    />
                </div>
            </HeaderElement>
            <HeaderElement>
                <HeaderElement
                    paddingRight={20}
                    fill={color}
                >
                    <a  href="https://twitter.com/AndSzesztai"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <TwitterLogo
                            className="icon"
                        />
                    </a>
                </HeaderElement>
                <HeaderElement
                    paddingRight={20}
                    fill={color}
                    >
                    <a  href="https://www.linkedin.com/in/andr%C3%A1s-szesztai-351a4379/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <LinkedinLogo
                            className="icon"
                        />
                    </a>
                </HeaderElement>
                <HeaderElement
                    fill={color}
                >
                    <a  href="https://github.com/andras-newzoo"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <GitHubLogo
                            className="icon"
                        />
                    </a>
                </HeaderElement>
            </HeaderElement>
        </HeaderContainer>
     );
}
 
export default Header;